(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('checkbox', [function () {
    return {
      template: "\n                <div style=\"display: inline-block;\">\n                    <input class=\"{{ ::inputClass }}\" id=\"{{ ::id }}\" type=\"checkbox\" ng-model=\"model\">\n                    <label class=\"{{ ::labelClass }}\" for=\"{{ ::id }}\"><span>{{ ::label }}</span></label>\n                </div>\n            ",
      scope: {
        model: '=',
        label: '@'
      },
      link: function link(scope, element, attrs) {
        scope.id = new Date();
        var compact = Object.keys(attrs).indexOf('compact') > -1 ? 'tiny' : '';
        var transparent = Object.keys(attrs).indexOf('transparent') > -1 ? 'transparent' : '';
        scope.inputClass = "checkbox-input";
        scope.labelClass = "checkbox-label ".concat(compact, " ").concat(transparent);
      }
    };
  }]);
})();
